import { useEffect } from 'react';
import { SITE_URL, BRAND } from '../lib/site';

const upsertMeta = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const breadcrumbLd = (items) => ({
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({ '@type': 'ListItem', position: i + 1, name: it.name, item: `${SITE_URL}${it.path}` })),
});

export const faqLd = (faqs) => ({
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
});

// Per-route SEO manager (title, description, canonical, OG/Twitter, JSON-LD @graph).
export const Seo = ({ title, description, path = '', noindex = false, jsonLd = null, breadcrumbs = null, image = `${SITE_URL}/og-image.png` }) => {
  const graph = [];
  if (jsonLd) graph.push(...(Array.isArray(jsonLd) ? jsonLd : (jsonLd['@graph'] || [jsonLd])));
  if (breadcrumbs) graph.push(breadcrumbLd(breadcrumbs));
  const jsonLdStr = graph.length ? JSON.stringify({ '@context': 'https://schema.org', '@graph': graph.map(({ '@context': _c, ...rest }) => rest) }) : '';

  useEffect(() => {
    if (title) document.title = title;
    const url = SITE_URL + path;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    upsertLink('canonical', url);
    upsertMeta('property', 'og:site_name', BRAND);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', image);
    upsertMeta('property', 'og:image:width', '1200');
    upsertMeta('property', 'og:image:height', '630');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', image);

    const el = document.getElementById('seo-jsonld');
    if (jsonLdStr) {
      let s = el;
      if (!s) {
        s = document.createElement('script');
        s.id = 'seo-jsonld';
        s.type = 'application/ld+json';
        document.head.appendChild(s);
      }
      s.textContent = jsonLdStr;
    } else if (el) {
      el.remove();
    }
  }, [title, description, path, noindex, jsonLdStr, image]);
  return null;
};
